module.exports = __webpack_public_path__ + "img/spfc2.7bfbb1bc.jpg";